<template>
    <div class="tri blocklist-row" :class="topicClass">
        <div class="standard">            
            <div class="col-status">
                <!-- <span v-if="topic.participated"><img class="icon-participated" src="/icons/icon_participated.png" /></span> -->
                <img :src="topicIcon"/>
            </div>
            <div class="smalltop">
                <div class="col-topic"><router-link :to="{ path: '/topics/' + post.topicID + '?post=unread'}">{{ post.topicTitle | decodeHtml }}</router-link></div>            
                <div class="col-board"><router-link :to="{ path: '/boards/' + post.boardID }">{{ post.boardName | decodeHtml }}</router-link></div>
                <div class="col-starter"><router-link :to="{path: '/members/' + post.memberID}">{{ post.memberDisplayName }}</router-link></div>
            </div>
            <div class="smallbot">
                <div class="content-container">
                    <PostContent :content="post.content"> </PostContent>
                </div>
            </div>
        </div>        
        <div class="mobile">
            <div class="col-status"><img :src="topicIcon"/></div>
            <div class="tli-content">
                <div class="col-topicinfo"><router-link :to="{ path: '/topics/' + post.topicID + '?post=unread'}">{{ post.topicTitle | decodeHtml }}</router-link></div>
                <div class="col-startinfo">
                    By {{ post.memberDisplayName }}
                </div>
                <div class="content-container">
                    <PostContent :content="post.content"> </PostContent>
                </div>
            </div>            
        </div>
    </div>    
</template>

<script>

    import topicHelper from '../../modules/topics/statusHelper'
    import PostContent from '../../components/Posts/PostContent';

    export default {        
        props: ['post'],
        components: {
            PostContent
        },
        computed: {
            topicClass() {
                return topicHelper.getClass(this.post.status);   
            },
            topicIcon() {
                return topicHelper.getIcon(this.post, null);
            }            
        }
    }
</script>

<style scoped>
.col-topic{
    width:6%;
}
.content-container{
    display: inline-block;
    width: 55%;
    max-height: 91px;
    overflow-y: auto;
}

@media (min-width: 701px) and (max-width: 1063px) {
    .content-container{
        display: inline-block;
        width: 90%;
        max-height: 91px;
        overflow-y: auto;
        box-sizing: border-box;
        width: 110%;
    }
}

@media  (max-width: 700px) {
    .content-container{
        display: inline-block;
        width: 96% !important;
        max-height: 91px;
        overflow-y: auto;
        box-sizing: border-box;
        width: 110%;
    }
}
</style>